import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import SideBar from "./components/layout/sidebar";
import Index from "./components/Index";
import Status_404 from "./components/status/404";
import PostTable from "./components/posts/PostTable";
import NewPost from "./components/posts/NewPost";
import NewOpportunity from "./components/opportunities/NewOpportunity";
import OpportunityTable from "./components/opportunities/OpportunityTable";
import Consultation from "./components/consultation/Consultation";
import ConsultationUnSeen from "./components/consultation/ConsultationUnSeen";
import NewStudyOpportunity from "./components/studyOpportunities/NewOpportunity";
import NewCountry from "./components/country/NewCountry";
import NewEntrepreneurship from "./components/entrepreneurship/NewEntrepreneurship";
import CommentTable from "./components/comments/CommentTable";
import AcceptComment from "./components/comments/AcceptComment";
import DeletedComments from "./components/comments/DeletedComments";
import StudyOpportunityTable from "./components/studyOpportunities/StudyOpportunityTable";
import CountryList from "./components/country/CountryList";
import CountryEdit from "./components/country/CountryEdit";
import EntrepreneurshipList from "./components/entrepreneurship/EntrepreneurshipList";
import EditEntrepreneurship from "./components/entrepreneurship/EditEntrepreneurship";
import EditPost from "./components/posts/EditPost";
import EditOpportunity from "./components/opportunities/EditOpportunity";
import EditStudyOpper from "./components/studyOpportunities/EditStudyOpper";
import ResumeTable from "./components/resume/All-resume";
import UserTable from "./components/user/UserTable";
import JobResume from "./components/resume/Job-resume";
import EducationResume from "./components/resume/Education-resume";
import Messenger from "./components/Chat/Messenger";
import Chat from "./components/Chat/Chat";
import Customers from "./components/Customers/Customers";
import ClientMessenger from "./components/Chat/Client/ClientMessenger";
import ConsultationFree from "./components/consultation/ConsultationFree";
import ConsultationPaid from "./components/consultation/ConsultationPaid";
import Register from "./components/Auth/Register";
import Login from "./components/Auth/Login";
import AuthPassword from "./components/Auth/AuthPassword";
import NewResumes from "./components/resume/NewResumes";
import CreateGiftCode from "./components/gift-code/create-gift-code";
import GiftCodes from "./components/gift-code/gift-codes";
import EditGiftCode from "./components/gift-code/edit-gift-code";
import AppNotification from "./components/Notification/app-notification";
import PWANotification from "./components/Notification/pwa-notification";
import EduResumeList from "./components/resume/edu-resume-list";
import JobResumeList from "./components/resume/job-resume-list";
import NewOpperFile from "./components/opportunities/new-opper-file";
import EditVersion from "./components/version/editVersion";
import NewStudyOpperFile from "./components/studyOpportunities/new-study-opper-file";

export default function App() {
  return (
    <Router basename="/">
       <SideBar />
        <Switch>
            <Route path="/messenger" component={Messenger} exact />
            <Route path="/client-messenger" component={ClientMessenger} exact />
            <Route path="/messenger/chat/:roomId" component={Chat} exact />
            <Route path="/" component={Index} exact />

            {/*posts*/}
            <Route path="/post-table" component={PostTable} />
            <Route path="/post-new" component={NewPost} />
            <Route path="/post-edit/:id" component={EditPost} />

            {/*opportunity*/}
            <Route
              path="/opportunity-table"
              component={OpportunityTable}
              name="oppo-table"
            />
            <Route
              path="/opportunity-new"
              component={NewOpportunity}
              name="oppo-new"
            />
            <Route
              path="/opportunity-new-file"
              component={NewOpperFile}
              name="oppo-new-file"
            />
            <Route path="/opportunity-edit/:id" component={EditOpportunity} />

            {/*study opportunity*/}
            <Route
              path="/study-opportunity-table"
              component={StudyOpportunityTable}
              name="study-oppo-table"
            />
            <Route
              path="/study-opportunity-new"
              component={NewStudyOpportunity}
              name="study-oppo-new"
            />
            <Route
              path="/opportunity-edu-new-file"
              component={NewStudyOpperFile}
              name="oppo-edu-new-file"
            />
            <Route path="/editstudyopper/:id" component={EditStudyOpper} />

            {/*consultation*/}
            <Route path="/consultation-table" component={Consultation} />
            <Route path="/consultation-free" component={ConsultationFree} />
            <Route path="/consultation-paid" component={ConsultationPaid} />
            <Route
              path="/consultation-unseen-table"
              component={ConsultationUnSeen}
            />

            {/*resume*/}
            <Route path="/all-resume" component={ResumeTable} />
            <Route path="/job-resume/:id" component={JobResume} />
            <Route path="/education-resume/:id" component={EducationResume} />
            <Route path="/new-resumes" component={NewResumes} />
            <Route path="/resume-for-edus" component={EduResumeList} />
            <Route path="/resume-for-jobs" component={JobResumeList} />

            {/*user*/}
            <Route path="/all-user" component={UserTable} />

            {/*country*/}
            <Route path="/new-country" component={NewCountry} />
            <Route path="/country-list" component={CountryList} />
            <Route path="/country-edit/:id" component={CountryEdit} />

            {/*Entrepreneurship*/}
            <Route
              path="/new-entrepreneurship"
              component={NewEntrepreneurship}
            />
            <Route path="/entrepreneurships" component={EntrepreneurshipList} />
            <Route
              path="/entrepreneurship-edit/:id"
              component={EditEntrepreneurship}
            />

            {/*comment*/}
            <Route path="/all-comments" component={CommentTable} />
            <Route path="/get-comments" component={AcceptComment} />
            <Route path="/deleted-comments" component={DeletedComments} />

            {/*Customers*/}
            <Route path="/customers" component={Customers} />

            {/*gift Code*/}
            <Route path="/create-gift-code" component={CreateGiftCode} />
            <Route path="/edit-gift-code/:id" component={EditGiftCode} />
            <Route path="/gift-codes" component={GiftCodes} />

            {/*Notification*/}
            <Route path="/app-notification" component={AppNotification} />
            <Route path="/pwa-notification" component={PWANotification} />

            {/*App Version*/}
            <Route path="/app-version" component={EditVersion} />

            <Route component={Status_404} />
        </Switch>
        <>
          <Route path="/login" component={Login} exact />
          <Route path="/register" component={Register} exact />
          <Route path="/auth-code" component={AuthPassword} exact />
        </>
    </Router>
  );
}
